<template>

  <div>

    <b-navbar
        class="shadow  bg-nav text-white nav-top-border"
        toggleable="lg"
        type="light"
        variant="fade">

      <router-link :to="{ name: 'Home' }">
        <b-navbar-brand>
          <b-img
              :src="findAttributeOnSiteInfo('icon')[0]"
              height="130"
          />
        </b-navbar-brand>
      </router-link>


      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="mr-4" v-for="menu in storeMenus" :key="menu.id" v-if="menu.position==='store_nav'">

          <NavMenuItem v-for="item in menu.children" :item="item" :key="item.id"/>


        </b-navbar-nav>
      </b-collapse>

    </b-navbar>

  </div>


</template>

<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem";


export default {
  name: "MainMenu",
  components: {NavMenuItem,},
  data() {
    return {
      categoryShow: false,
    }
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getStoreMenus"
    }),

  },
  mounted() {

  }
}
</script>

<style scoped>

.categories {
  list-style: none;
}

.nav-top-border {
  border-radius: 1rem;
}

.bg-nav {
  background-color: var(--primary) !important;
}

#categories {
  position: absolute;
  z-index: 2;
  background: var(--white) !important;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  padding: 1rem;
  width: 100%;
}

.navbar-brand img {
  height: 45px;
}
</style>